import { render, staticRenderFns } from "./JiShiClockRoom.vue?vue&type=template&id=3620a855&scoped=true&"
import script from "./JiShiClockRoom.vue?vue&type=script&lang=js&"
export * from "./JiShiClockRoom.vue?vue&type=script&lang=js&"
import style0 from "./JiShiClockRoom.vue?vue&type=style&index=0&id=3620a855&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620a855",
  null
  
)

export default component.exports